module.exports = __webpack_public_path__ + "static/media/uy.513b6266.svg";